export default __webpack_public_path__ + "7267513295665e54141bce08fd39eb14.webp";